<template>
    <div>
        <!--계열사 개인정보 -->
        <div class="modal fade modalStyle" id="piMody1" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog" style="width:100%; max-width:510px">
                <div class="modal-content">
                    <div class="modal-body">
                        <a class="ModalClose" data-dismiss="modal" title="닫기"><i class="fa-solid fa-xmark"></i></a>
                        <h2 class="modalTitle">개인정보</h2>
                        <div class="flex align-items-center">
                            <div class="formTit flex-shrink0 width120px">로그인ID</div>
                            <div class="width100">{{ this.$store.state.loginInfo.userId }}</div>
                        </div>
                        <div class="flex align-items-center mt20">
                            <div class="formTit flex-shrink0 width120px">이름</div>
                            <div class="width100">{{ this.$store.state.loginInfo.userName }}</div>
                        </div>
                        <div class="flex align-items-center mt20">
                            <div class="formTit flex-shrink0 width120px">소속 계열사</div>
                            <div class="width100">{{ this.$store.state.loginInfo.custName }}</div>
                        </div>
                        <div class="flex align-items-center mt20">
                            <div class="formTit flex-shrink0 width120px">사용자 권한</div>
                            <div class="width100" v-if="this.$store.state.loginInfo.userAuth == '1'">시스템관리자</div>
                            <div class="width100" v-if="this.$store.state.loginInfo.userAuth == '2'">각사관리자</div>
                            <div class="width100" v-if="this.$store.state.loginInfo.userAuth == '3'">일반관리자</div>
                            <div class="width100" v-if="this.$store.state.loginInfo.userAuth == '4'">감사사용자</div>
                        </div>
                        <div class="flex align-items-center mt20">
                            <div class="formTit flex-shrink0 width120px">입찰권한</div>
                            <div class="width100">
                                <input type="checkbox" v-model="openauth" id="checkbox1" class="checkStyle" disabled>
                                <label for="checkbox1"><div>개찰</div></label>&nbsp&nbsp&nbsp&nbsp
                                <input type="checkbox" v-model="bidauth" id="checkbox2" class="checkStyle" disabled>
                                <label for="checkbox2"><div>낙찰</div></label>
                            </div>
                        </div>
                        <div class="flex align-items-center mt10">
                            <div class="formTit flex-shrink0 width120px">비밀번호</div>
                            <div class="flex align-items-center width100">
                                <div class="width100">최종변경일 : {{ userInfo.pwdEditDate }}</div>
                                <!--<a data-toggle="modal" @click="changePwd" class="btnStyle btnSecondary btnSm flex-shrink0 ml10" title="비밀번호 변경">비밀번호 변경</a>-->
                            </div>
                        </div>
                        <div class="flex align-items-center mt10">
                            <div class="formTit flex-shrink0 width120px">휴대폰 <span class="star">*</span></div>
                            <div class="width100"><input type="text" class="inputStyle" v-model.trim="userInfo.userHp"></div>
                        </div>
                        <div class="flex align-items-center mt10">
                            <div class="formTit flex-shrink0 width120px">유선전화 <span class="star">*</span></div>
                            <div class="width100"><input type="text" class="inputStyle" v-model.trim="userInfo.userTel"></div>
                        </div>
                        <div class="flex align-items-center mt10">
                            <div class="formTit flex-shrink0 width120px">이메일 <span class="star">*</span></div>
                            <div class="width100"><input type="text" class="inputStyle" v-model="userInfo.userEmail"></div>
                        </div>
                        <div class="flex align-items-center mt10">
                            <div class="formTit flex-shrink0 width120px">직급</div>
                            <div class="width100"><input type="text" class="inputStyle" v-model="userInfo.userPosition"></div>
                        </div>
                        <div class="flex align-items-center mt10">
                            <div class="formTit flex-shrink0 width120px">부서</div>
                            <div class="width100"><input type="text" class="inputStyle" v-model="userInfo.deptName"></div>
                        </div>

                        <div class="modalFooter">
                            <a class="modalBtnClose" data-dismiss="modal" title="취소">취소</a>
                            <a class="modalBtnCheck" data-toggle="modal" @click="confirm" title="저장">저장</a>
                        </div>
                    </div>				
                </div>
            </div>
        </div>
        <!-- //계열사 개인정보 -->

        <!--협력사 개인정보 -->
        <div class="modal fade modalStyle" id="piMody2" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog" style="width:100%; max-width:510px">
                <div class="modal-content">
                    <div class="modal-body">
                        <a class="ModalClose" data-dismiss="modal" title="닫기"><i class="fa-solid fa-xmark"></i></a>
                        <h2 class="modalTitle">개인정보</h2>
                        <div class="flex align-items-center">
                            <div class="formTit flex-shrink0 width120px">로그인ID</div>
                            <div class="width100">{{ this.$store.state.loginInfo.userId }}</div>
                        </div>
                        <div class="flex align-items-center mt20">
                            <div class="formTit flex-shrink0 width120px">이름</div>
                            <div class="width100">{{ this.$store.state.loginInfo.userName }}</div>
                        </div>
                        <div class="flex align-items-center mt10">
                            <div class="formTit flex-shrink0 width120px">비밀번호</div>
                            <div class="flex align-items-center width100">
                                <div class="width100">최종변경일: {{ userInfo.pwdChgDate }}</div>
                                <!--<a data-toggle="modal" @click="changePwd" class="btnStyle btnSecondary btnSm flex-shrink0 ml10" title="비밀번호 변경">비밀번호 변경</a>-->
                            </div>
                        </div>
                        <div class="flex align-items-center mt10">
                            <div class="formTit flex-shrink0 width120px">휴대폰 <span class="star">*</span></div>
                            <div class="width100"><input type="text" class="inputStyle" v-model.trim="userInfo.userHp"></div>
                        </div>
                        <div class="flex align-items-center mt10">
                            <div class="formTit flex-shrink0 width120px">유선전화 <span class="star">*</span></div>
                            <div class="width100"><input type="text" class="inputStyle" v-model.trim="userInfo.userTel"></div>
                        </div>
                        <div class="flex align-items-center mt10">
                            <div class="formTit flex-shrink0 width120px">이메일 <span class="star">*</span></div>
                            <div class="width100"><input type="text" class="inputStyle" v-model.trim="userInfo.userEmail"></div>
                        </div>
                        <div class="flex align-items-center mt10">
                            <div class="formTit flex-shrink0 width120px">직급</div>
                            <div class="width100"><input type="text" class="inputStyle" v-model="userInfo.userPosition"></div>
                        </div>
                        <div class="flex align-items-center mt10">
                            <div class="formTit flex-shrink0 width120px">부서</div>
                            <div class="width100"><input type="text" class="inputStyle" v-model="userInfo.userBuseo"></div>
                        </div>

                        <div class="modalFooter">
                            <a class="modalBtnClose" data-dismiss="modal" title="취소">취소</a>
                            <a class="modalBtnCheck" data-toggle="modal" @click="confirm" title="저장">저장</a>
                        </div>
                    </div>				
                </div>
            </div>
        </div>
        <!-- //협력사 개인정보 -->

        <!-- confirm 창 -->
		<div class="modal fade modalStyle" id="infoSave" tabindex="-1" role="dialog" aria-hidden="true">
			<div class="modal-dialog" style="width:100%; max-width:420px">
				<div class="modal-content">
					<div class="modal-body">
						<a  class="ModalClose" data-dismiss="modal" title="닫기"><i class="fa-solid fa-xmark"></i></a>
						<div class="alertText2">개인정보를 변경하시겠습니까?</div>
						<div class="modalFooter">
							<a  class="modalBtnClose" data-dismiss="modal" title="취소">취소</a>
							<a  @click="saveInfo" class="modalBtnCheck" data-toggle="modal" title="저장">저장</a>
						</div>
					</div>				
				</div>
			</div>
		</div>
        <!-- //confirm 창 -->

        <!-- 개인정보 저장 얼럿 -->
        <div class="modal fade modalStyle" id="piMody3" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog" style="width:100%; max-width:420px">
                <div class="modal-content">
                    <div class="modal-body">
                        <a class="ModalClose" data-dismiss="modal" title="닫기"><i class="fa-solid fa-xmark"></i></a>
                        <div class="alertText2">개인정보를 수정하였습니다.</div>
                        <div class="modalFooter">
                            <a class="modalBtnClose" data-dismiss="modal" title="닫기">닫기</a>
                        </div>
                    </div>				
                </div>
            </div>
        </div>
        <!-- //개인정보 저장 얼럿 -->
    </div>

</template>
<script>
export default {
    name: 'PersonalInfo',

    mounted(){
        
    }, 
    watch: {
        bidauth(newValue) {
            if (newValue !== 1) {
                this.data1 = 0; // data1이 1이 아니면 체크박스 해제
            }
        },
        openauth(newValue) {
            if (newValue !== 1) {
                this.data2 = 0; // data2가 1이 아니면 체크박스 해제
            }
        },
		//휴대폰번호
		'userInfo.userHp'(){
			this.userInfo.userHp = this.hpNumberAddDash(this.userInfo.userHp);
		},
		//유선전화
		'userInfo.userTel'(){
			this.userInfo.userTel = this.hpNumberAddDash(this.userInfo.userTel);
		}
    },
    data() {
        return {
            userInfo:{},
            bidauth: false,
            openauth: false
        };
    },
    methods: {

        async selectUserInfo(){//유저 정보 조회
            
            try {
                this.$store.commit('loading');
                const response = await this.$http.post('/api/v1/main/selectUserInfo', {});
                if(response.data.code == 'OK'){
                    this.userInfo = response.data.data;
                    
                    if(this.$store.state.loginInfo.custType == 'inter'){
                        this.bidauth = this.userInfo.bidauth == '1';
                        this.openauth = this.userInfo.openauth == '1';
                    }

                }else{
                    this.$swal({
                        type: "error",
                        text: response.data.msg,//에러 메시지
                    });
                }
                this.$store.commit('finish');
            } catch(err) {
                console.log(err)
                this.$store.commit('finish');
            }
        },
        async saveInfo(){
            if(this.$store.state.loginInfo.custType == 'inter'){
                this.userInfo.bidauth = this.bidauth;
                this.userInfo.openauth = this.openauth;
            }

            try {
                this.$store.commit('loading');
                const response = await this.$http.post('/api/v1/main/saveUserInfo', this.userInfo);

                if(response.data.code == 'OK'){
                    $('#infoSave').modal('hide');
                    $('#piMody1').modal('hide');
                    $('#piMody2').modal('hide');
                    $('#piMody3').modal('show');
                }else{
                    this.$swal({
                        type: "error",
                        text: response.data.msg,        //에러 메시지
                    });
                }
                this.$store.commit('finish');
            } catch(err) {
                console.log(err)
                this.$store.commit('finish');
            }
        },
        confirm(){//개인정보 변경
            if(!this.validChek()){
                return false;
            }

            $('#infoSave').modal('show');
        },
        validChek(){
            if(this.userInfo.userHp == null || this.userInfo.userHp == ''){
                this.$swal({
                    type: "warning",
                    text: '휴대폰 번호를 입력해주세요.',
                });
                return false;
            }else if(this.userInfo.userTel == null || this.userInfo.userTel == ''){
                this.$swal({
                    type: "warning",
                    text: '유선전화 번호를 입력해주세요.',
                });
                return false;
            }else if(this.userInfo.userEmail == null || this.userInfo.userEmail == ''){
                this.$swal({
                    type: "warning",
                    text: '이메일을 입력해주세요.',
                });
                return false;
            }else if(!this.validateEmail(this.userInfo.userEmail)){
                this.$swal({
                    type: "warning",
                    text: '이메일 형식에 맞게 작성해주세요.',
                });
                return false;
            }

            return true;
        },
        validateEmail(email) {
            // 이메일 주소를 검사하기 위한 정규 표현식
            const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            
            // 정규 표현식을 사용하여 이메일 주소를 검사하고 결과를 반환
            return regex.test(email);
        },
        //전화번호 입력 시 대시 입력
        hpNumberAddDash(val){
            if (!val) return '';
            val = val.toString();
            val = val.replace(/[^0-9]/g, '')
            
            let tmp = ''
            if( val.length < 4){
            return val;
            } else if(val.length <= 7) {
            tmp += val.substr(0, 3);
            tmp += '-';
            tmp += val.substr(3);
            return tmp;
            } else if(val.length == 8) {
            tmp += val.substr(0, 4);
            tmp += '-';
            tmp += val.substr(4);
            return tmp;
            } else if(val.length < 10) {
            tmp += val.substr(0, 2);
            tmp += '-';
            tmp += val.substr(2, 3);
            tmp += '-';
            tmp += val.substr(5);
            return tmp;
            } else if(val.length < 11) {
            if(val.substr(0, 2) =='02') { //02-1234-5678
                tmp += val.substr(0, 2);
                tmp += '-';
                tmp += val.substr(2, 4);
                tmp += '-'
                tmp += val.substr(6);
                return tmp;
            } else { //010-123-4567
                tmp += val.substr(0, 3);
                tmp += '-';
                tmp += val.substr(3, 3);
                tmp += '-';
                tmp += val.substr(6);
                return tmp;
            }
            } else { //010-1234-5678
            tmp += val.substr(0, 3);
            tmp += '-';
            tmp += val.substr(3, 4);
            tmp += '-';
            tmp += val.substr(7);
            return tmp;
            }
        }
    }
}
</script>
<style>
    
</style>